import { useEffect } from 'react'
import { ArrayInput, required, SelectInput, SimpleFormIterator, TextInput, useResourceContext } from 'react-admin'
import { useFormContext, useWatch } from 'react-hook-form'

import { ERROR_MESSAGES } from '../config/errors'
import { NFC_CARD_TYPES } from '../config/nfc'
import { SimpleFormIteratorAddButton } from '../resources/common/forms'

const nfcTypesChoices = Object.entries(NFC_CARD_TYPES).map(([k, v]) => ({ id: k, name: v }))

const validateUniqueCardIds = (value) => {
  if (!value?.length) return undefined
  const cardIds = value.map((card) => card?.card_id).filter(Boolean)
  return cardIds.length !== new Set(cardIds).size ? ERROR_MESSAGES.nfc_card_duplicate : undefined
}

const NFCArrayInput = ({ source, maxAmount }) => {
  const nfcCards = useWatch({ name: source })
  const { clearErrors } = useFormContext()
  const resource = useResourceContext()
  const fieldPrefix = `resources.${resource}.fields.${source}`

  useEffect(() => {
    if (!nfcCards?.length) {
      clearErrors(source)
    }
  }, [nfcCards, clearErrors, source])

  return (
    <ArrayInput source={source} label={`${fieldPrefix}.name`} helperText={false} validate={validateUniqueCardIds}>
      <SimpleFormIterator
        disableReordering
        TransitionProps={{ enter: false, exit: false }}
        addButton={<SimpleFormIteratorAddButton />}
        disableAdd={nfcCards?.length >= maxAmount}
        inline
      >
        <SelectInput
          source="nfc_type"
          label={`${fieldPrefix}.nfc_type`}
          choices={nfcTypesChoices}
          validate={required()}
        />
        <TextInput source="card_id" label={`${fieldPrefix}.card_id`} validate={required()} />
      </SimpleFormIterator>
    </ArrayInput>
  )
}

export default NFCArrayInput
